/** Cache key for the student's classes, items and posts (shared by several API files). */
export const SCHOOLWORK_KEY = ["schoolwork"];
